<script setup>
import { computed, onMounted } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { persistShopifyPendingInstall } from 'v3/helpers/AuthHelper';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Testimonials from '../auth/signup/components/Testimonials/Index.vue';

// TODO: stub — replace with full design when specified.
const globalConfig = useMapGetter('globalConfig/get');
const bootstrap = window.shopifyAccountExists || {};

const email = computed(() => bootstrap.email || '');
const shopName = computed(() => bootstrap.shopName || '');
const loginUrl = computed(() => {
  const params = new URLSearchParams();
  if (email.value) params.set('email', email.value);
  if (bootstrap.pendingToken)
    params.set('shopify_pending', bootstrap.pendingToken);
  const query = params.toString();
  return query ? `/app/login?${query}` : '/app/login';
});

const goToLogin = () => {
  persistShopifyPendingInstall(bootstrap.pendingToken);
  window.location = loginUrl.value;
};

onMounted(() => {
  persistShopifyPendingInstall(bootstrap.pendingToken);
  document.body.classList.remove('dark');
  document.documentElement.style.setProperty('color-scheme', 'light');
});
</script>

<template>
  <div class="w-full h-full min-h-screen bg-gray-50">
    <div class="flex h-full min-h-screen flex-col lg:flex-row">
      <div
        class="flex-1 lg:w-1/2 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-8 lg:py-12 bg-white"
      >
        <div class="w-full max-w-md space-y-8">
          <div class="text-left">
            <img
              :src="globalConfig.logo"
              :alt="globalConfig.installationName"
              class="h-8 w-auto"
            />
            <h1
              class="mt-6 text-2xl font-medium tracking-tight text-n-slate-12"
            >
              {{ $t('SHOPIFY_ACCOUNT_EXISTS.HEADING') }}
            </h1>
            <p v-if="shopName" class="mt-2 text-sm text-gray-600">
              {{ $t('SHOPIFY_ACCOUNT_EXISTS.BODY', { email, shopName }) }}
            </p>
            <p v-else class="mt-2 text-sm text-gray-600">
              {{ $t('SHOPIFY_ACCOUNT_EXISTS.BODY_NO_SHOP', { email }) }}
            </p>
            <p class="mt-4 text-xs text-gray-500">
              {{ $t('SHOPIFY_ACCOUNT_EXISTS.HELP') }}
            </p>
          </div>

          <NextButton
            lg
            type="button"
            class="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition duration-200 shadow-sm"
            :label="$t('SHOPIFY_ACCOUNT_EXISTS.LOGIN')"
            @click="goToLogin"
          />
        </div>
      </div>

      <div
        class="hidden lg:flex lg:w-1/3 bg-gradient-to-br from-blue-600 to-blue-800 relative overflow-hidden"
      >
        <div
          class="relative z-10 flex flex-col justify-center px-8 xl:px-12 py-12 text-white bg-n-brand"
        >
          <Testimonials />
        </div>
      </div>
    </div>
  </div>
</template>
